import { MODUS_ICON_BUTTON_STYLESHEET } from './mc-icon-button.css';

export const MODUS_BUTTON_INVERSE_STYLESHEET = `

  ${MODUS_ICON_BUTTON_STYLESHEET}
  .inverse-button {
    color: white !important;
  }
  .inverse-button:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
    color: white !important;
  }

  .mc-button-content--with-subtitle {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--modus-wc-spacing-xs, 6px);
  }

  .mc-button-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .mc-button-subtitle {
    color: var(--modus-wc-color-base-content-low-contrast);
    font-size: var(--modus-wc-font-size-xs, 0.75rem);
    font-weight: var(--modus-wc-font-weight-light, 300);
  }
`;

/** Injected by modus-ui Button on mount (inverse layout + subtitle styles). */
export const MODUS_BUTTON_STYLESHEET = MODUS_BUTTON_INVERSE_STYLESHEET;
